import { APP_PLATFORM } from '@m2h/common/constants';
import { getI18nParams } from '@m2h/common/utils';

// const logan = Mach.requireModule('Logan');

const defaultTags = {
  appVersion: Mach?.env?.version ?? '', // APP版本号
  appName: Mach?.env?.appName ?? '', // APP名称
  bundleName: Mach?.env?.bundleName ?? '', // Bundle 名称（主包）
  bundleVersion: Mach?.env?.bundleVersion ?? '', // Bundle 版本（主包）
  platform: Mach?.env?.platform || APP_PLATFORM.h5,
  env: Mach?.env?.isDebug ? 'Test' : 'Prod', // 环境
};

const getDefaultInfo = () => ({
  i18n: getI18nParams(),
  unionid: window.Owl?.cfgManager.getExtension('unionId'),
  os: window.Owl.cfgManager.getExtension().os || '',
  appVersion: Mach?.env?.version ?? '', // APP版本号
  appName: Mach?.env?.appName ?? '', // APP名称
  bundleName: Mach?.env?.bundleName ?? '', // Bundle 名称（主包）
  bundleVersion: Mach?.env?.bundleVersion ?? '', // Bundle 版本（主包）
  platform: Mach?.env?.platform || APP_PLATFORM.h5,
  env: Mach?.env?.isDebug ? 'Test' : 'Prod', // 环境
});

const loganLog = (msg: string, tags?: object) => {
  // TODO 暂时注释，logan调用次数太多，需要治理
  // console.log(msg, tags);
  try {
    if (window.Owl) {
      const distMsg = {
        errorMsg: msg,
        commonTags: getDefaultInfo(),
        customTags: tags || {},
      };
      window?.Owl?.addLog(JSON.stringify(distMsg));
    }
  } catch (e) {
    console.log('Logan log异常：', e);
  }
};

// native版本
// 写入 Logan 日志
// const loganLog = (msg: string, tags?: object) => {
//   console.log(msg, tags);
//   const distMsg = {
//     errorMsg: msg,
//     commonTags: defaultTags,
//     customTags: tags || {},
//   };
//   logan?.log(JSON.stringify(distMsg));
// };

export default loganLog;
